// extracted by mini-css-extract-plugin
export default {"emptyList":"EmptyState_emptyList__0DLAD","iconHistory":"EmptyState_iconHistory__XGJtD","icon":"EmptyState_icon__-aF4d"};